const campaignTypes = {
    LIST_PENDING: "CAMPAIGNS_LIST_PENDING",
    LIST_SUCCESS: "CAMPAIGNS_LIST_SUCCESS",
    LIST_ERROR: "CAMPAIGNS_LIST_ERROR",

    DETAIL_PENDING: "CAMPAIGN_DETAIL_PENDING",
    DETAIL_SUCCESS: "CAMPAIGN_DETAIL_SUCCESS",
    DETAIL_ERROR: "CAMPAIGN_DETAIL_ERROR",

    RECIPIENTS_PENDING: "CAMPAIGN_RECIPIENTS_PENDING",
    RECIPIENTS_SUCCESS: "CAMPAIGN_RECIPIENTS_SUCCESS",
    RECIPIENTS_ERROR: "CAMPAIGN_RECIPIENTS_ERROR",

    CREATE_PENDING: "CAMPAIGN_CREATE_PENDING",
    CREATE_SUCCESS: "CAMPAIGN_CREATE_SUCCESS",
    CREATE_ERROR: "CAMPAIGN_CREATE_ERROR",

    PAUSE_PENDING: "CAMPAIGN_PAUSE_PENDING",
    PAUSE_SUCCESS: "CAMPAIGN_PAUSE_SUCCESS",
    PAUSE_ERROR: "CAMPAIGN_PAUSE_ERROR",

    RESUME_PENDING: "CAMPAIGN_RESUME_PENDING",
    RESUME_SUCCESS: "CAMPAIGN_RESUME_SUCCESS",
    RESUME_ERROR: "CAMPAIGN_RESUME_ERROR",

    CANCEL_PENDING: "CAMPAIGN_CANCEL_PENDING",
    CANCEL_SUCCESS: "CAMPAIGN_CANCEL_SUCCESS",
    CANCEL_ERROR: "CAMPAIGN_CANCEL_ERROR",

    TEMPLATES_PENDING: "CAMPAIGN_TEMPLATES_PENDING",
    TEMPLATES_SUCCESS: "CAMPAIGN_TEMPLATES_SUCCESS",
    TEMPLATES_ERROR: "CAMPAIGN_TEMPLATES_ERROR",

    ANALYTICS_PENDING: "CAMPAIGN_ANALYTICS_PENDING",
    ANALYTICS_SUCCESS: "CAMPAIGN_ANALYTICS_SUCCESS",
    ANALYTICS_ERROR: "CAMPAIGN_ANALYTICS_ERROR",
};

export default campaignTypes;
